import { useLanguage } from '../../../../LanguageProvider';
import Services from '../../../../services/Services';
import { useToaster } from '../../../../ToasterProvider';
import './SHSponsorCard.css'
import { CgCloseO } from 'react-icons/cg'

export default function SHSponsorCard({ name, title, image, isAdmin, eventID, sponsorID, getEventDetails }) {
    const token = localStorage.getItem("token")
    const { toastError } = useToaster();
    const { getTranslation } = useLanguage();

    const removeSpeaker = () => {
        Services.SocialHiveRemoveSponsor(token, eventID, sponsorID)
            .then((res) => {
                if (res.data.status) {
                    getEventDetails()
                } else {
                    toastError(getTranslation("somethingWentWrong"));
                }
            })
            .catch((err) => {
                console.error(err);
                toastError(getTranslation("somethingWentWrong"));
            });
    }
    return (
        <div className='sponsor-card-container'>
            <img src={image} height={32} alt={name} className='sponsor-avatar' />

            <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span className='sponsor-name' style={{ fontWeight: '700' }}>
                    {name}
                </span>
                <span className='sponsor-title'>
                    {title}
                </span>
            </div>

            {isAdmin === "1" &&
                <span style={{ top: -10, right: -5, position: 'absolute' }}>
                    <CgCloseO
                        onClick={removeSpeaker}
                        style={{
                            backgroundColor: 'var(--logo-title)',
                            cursor: "var(--pointer)",
                            minWidth: "14px",
                            minHeight: "14px",
                            width: "14px",
                            height: "14px",
                            borderRadius: '50%',
                            color: '#ccc'
                        }}
                    />
                </span>
            }
        </div>
    )
}
